// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","overlay":"Gfdae41"};